import React, { useEffect, useState } from "react";
import { FaEdit, FaKey } from "react-icons/fa";
import Layout, { Container } from "../components/layout";
import { FiEdit2 } from "react-icons/fi";
import axios from "axios";
import { useParams } from "react-router-dom";
import { apiurl } from "../config/config";
import { toast } from "react-toastify";
import { useUser } from "../config/userProvider";
import { getCookie } from "../config/webStorage";
import { p, span } from "framer-motion/client";
import { GoInfo } from "react-icons/go";

export default function EmployeeProfile() {
  let { userData } = useUser();
  let { employeeObjId } = useParams();
  const [employee, setEmployee] = useState(null);
  const [editing, setEditing] = useState({});
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showManagerModal, setShowManagerModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [password, setPassword] = useState({ new: "", confirm: "" });
  const [manager, setManager] = useState("");
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [documentLink, setDocumentLink] = useState("");
  const [editData, setEditData] = useState({ ...employee });
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  let token = getCookie("swtoken");

  const [managerSearch, setManagerSearch] = useState("");
  const [managerOptions, setManagerOptions] = useState([]);
  const [managerSelected, setManagerSelected] = useState(false);
  const [reportingDetails, setReportingDetails] = useState({
    managerName: "",
    managerEmployeeCode: "",
    managerId: "",
    managerObjId: "",
  });
  const [showExitModal, setShowExitModal] = useState(false);
  const [employeeStatus, setemployeeStatus] = useState("");

  const [exitData, setExitData] = useState({
    exitInitiatedDate: "",
    lastWorkingDay: "",
    exitReason: "",
    clearanceStatus: "",
    processBy: {
      userObjId: userData?._id,
      userId: userData.employeeDetails.employeeId,
      userName: userData.firstName + " " + userData.lastName,
      employeeCode: `SUW${userData.employeeDetails.employeeId}`,
    },
  });

  useEffect(() => {
    fetchEmployeeDetails(employeeObjId);
  }, [employeeObjId]);

  const fetchEmployeeDetails = () => {
    axios
      .get(`${apiurl}/api/employee/get/${employeeObjId}`)
      .then((res) => {
        setEmployee(res?.data?.employee);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching employee:", error);
        setLoading(false);
      });
  };

  const updateManager = async () => {
    try {
      const res = await axios.post(`${apiurl}/api/employee/assign-manager`, {
        employeeObjId: employee._id,
        reportingDetails, // this spreads all reportingDetails fields into the request body
      });

      //   alert("Updated Successfully!");
      toast.success("Updated Successfully!");
      fetchEmployeeDetails();
      setShowManagerModal(false);
    } catch (error) {
      console.error("Update Failed:", error);
      alert("Update Failed!");
    }
  };

  const updatePassword = async () => {
    if (passwords.newPassword !== passwords.confirmPassword) {
      // alert("Passwords do not match");
      toast.error("Passwords do not match");
      return;
    }

    try {
      const res = await axios.post(
        `${apiurl}/api/employee/change-password`,
        {
          employeeObjId: employee._id,
          newPassword: passwords.newPassword,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      toast.success("Password updated successfully");
      fetchEmployeeDetails();
      setShowPasswordModal(false);
    } catch (error) {
      toast.error("Failed to update password");
      alert("Update Failed!");
    }
  };

  // const handleUpdateEmployee = async () => {
  //   const payload = {
  //     employeeStatus: selectedEmployee.employeeStatus,
  //     department: selectedEmployee.department,
  //     designation: selectedEmployee.designation,
  //     personalDetails: {
  //       ...selectedEmployee.personalDetails,
  //     },
  //   };

  //   try {
  //     const response = await fetch(
  //       `${apiurl}/api/employee/update-employee-details/${selectedEmployee._id}`,
  //       {
  //         method: "PATCH",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(payload),
  //       }
  //     );
  //     const result = await response.json();

  //     if (response.ok) {
  //       alert("Employee updated successfully!");
  //       setShowUpdateModal(false);
  //       // Refresh data if needed
  //     } else {
  //       alert(result.message || "Failed to update employee");
  //     }
  //   } catch (error) {
  //     console.error("Error updating employee:", error);
  //   }
  // };

  const handleUpdateEmployee = async () => {
    // Compare old vs new personalDetails
    const isPersonalUpdated =
      JSON.stringify(selectedEmployee.personalDetails) !==
      JSON.stringify(employee.personalDetails);

    // Get updated identification fields only
    const updatedIdentification = {};
    if (selectedEmployee.identification && employee.identification) {
      for (const key in selectedEmployee.identification) {
        if (
          selectedEmployee.identification[key] !== employee.identification[key]
        ) {
          updatedIdentification[key] = selectedEmployee.identification[key];
        }
      }
    }

    const isIdentificationUpdated =
      Object.keys(updatedIdentification).length > 0;

    // Start building the payload
    const payload = {
      employeeStatus: selectedEmployee.employeeStatus,
      employeeId: selectedEmployee.employeeId,
      department: selectedEmployee.department,
      designation: selectedEmployee.designation,
      personalDetails: {
        ...selectedEmployee.personalDetails,
      },
    };

    if (isIdentificationUpdated) {
      payload.identification = updatedIdentification;
    }

    // Add verification info if needed
    if (isPersonalUpdated) {
      payload.personalDetails.verificationBy = {
        userObjId: userData?._id,
        userId: userData?.employeeDetails?.employeeId,
        userName: userData?.firstName + " " + userData?.lastName,
        employeeCode: `SUW${userData?.employeeDetails?.employeeId}`,
      };
    }
    if (isIdentificationUpdated) {
      payload.identification.verificationBy = {
        userObjId: userData?._id,
        userId: userData?.employeeDetails?.employeeId,
        userName: userData?.firstName + " " + userData?.lastName,
        employeeCode: `SUW${userData?.employeeDetails?.employeeId}`,
      };
    }

    try {
      const response = await fetch(
        `${apiurl}/api/employee/update-employee-details/${selectedEmployee._id}`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();

      if (response.ok) {
        alert("Employee updated successfully!");
        setShowUpdateModal(false);
      } else {
        alert(result.message || "Failed to update employee");
      }
    } catch (error) {
      console.error("Error updating employee:", error);
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (managerSearch.length > 2) {
        searchManagers(managerSearch);
      } else {
        setManagerOptions([]);
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [managerSearch]);

  const searchManagers = async (query) => {
    try {
      const res = await axios.post(
        `${apiurl}/api/employee/search?page=1&limit=10&search=${query}`
      );
      setManagerOptions(res.data.users || []);
    } catch (err) {
      console.error("Error fetching managers:", err);
    }
  };
  //   const searchManagers = async (query) => {
  //     try {
  //       const res = await axios.post(`${apiurl}/api/employee/search`, {
  //         search: query,
  //         // designation: ["assistant-manager", "team-leader"], // passed in body
  //         page: 1,
  //         limit: 10,
  //       });
  //       setManagerOptions(res.data.users || []);
  //     } catch (err) {
  //       console.error("Error fetching managers:", err);
  //     }
  //   };

  const renderValue = (value) => value || "NA";

  const handleExitSubmit = async () => {
    try {
      const res = await axios.post(`${apiurl}/api/employee/exit-process`, {
        employeeObjId: employee._id,
        exitProcess: exitData,
        employeeStatus,
      });

      toast.success("Exit process updated successfully");
      fetchEmployeeDetails();
      setShowExitModal(false);
    } catch (error) {
      toast.error("Failed to update exit process");
      alert("Update Failed!");
    }
  };

  // console.log("reportingDetails", reportingDetails);
  // console.log("exitData", exitData);
  // console.log("employeeStatus", employeeStatus);
  const hasReadPermission = (permissions, resourceKey) => {
    const perm = permissions?.find((p) => p.resource === resourceKey);
    return perm?.read === true;
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="bg-white rounded-2xl shadow-sm border p-6 w-full mb-4 mx-auto">
          {/* Header Section: Photo + Basic Info */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-6 mb-6">
            {/* Employee Photo */}
            <img
              src={employee?.documents?.photo?.link || "/images/user.png"}
              alt={
                employee?.personalDetails?.firstName +
                " " +
                employee?.personalDetails?.lastName
              }
              className="w-24 h-24 rounded-full object-cover border-2 border-gray-300 p-1"
            />

            {/* Name, Code, Phone */}
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-gray-800 capitalize">
                {`${employee?.personalDetails?.firstName || ""} ${
                  employee?.personalDetails?.lastName || ""
                }`.trim() || "N/A"}
              </h2>
              <p className="text-sm text-gray-500">
                Employee Code:{" "}
                <span className="font-medium">
                  {employee?.employeeCode || "N/A"}
                </span>
              </p>
              <p className="text-sm text-gray-500">
                Phone:{" "}
                <span className="font-medium">
                  {employee?.personalDetails?.phone || "N/A"}
                </span>
              </p>
              <p className="text-sm text-gray-500">
                Email:{" "}
                <span className="font-medium">
                  {employee?.personalDetails?.email || "N/A"}
                </span>
              </p>
            </div>

            {/* Status Badge */}
            <div className="sm:ml-auto">
              <span
                className={`px-3 py-1 rounded-full text-sm font-semibold ${
                  employee?.employeeStatus?.toLowerCase() === "active"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                {employee?.employeeStatus || "N/A"}
              </span>
            </div>
            {hasReadPermission(userData.permissions, "employee_details") && (
              <FaEdit
                onClick={() => {
                  setSelectedEmployee(employee);
                  setShowUpdateModal(true);
                }}
                className="text-blue-600 cursor-pointer"
              />
            )}
          </div>

          {/* Grid Info Section */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 text-sm text-gray-700">
            <p>
              <strong>ID:</strong> {renderValue(employee?.id)}
            </p>
            <p>
              <strong>Type:</strong> {renderValue(employee?.employeeType)}
            </p>
            <p>
              <strong>Department:</strong> {renderValue(employee?.department)}
            </p>
            <p>
              <strong>Designation:</strong> {renderValue(employee?.designation)}
            </p>
            <p>
              <strong>Office Location:</strong>{" "}
              {renderValue(employee?.officeLocation)}
            </p>
            <p>
              <strong>Joining Date:</strong>{" "}
              {employee?.employeeJoiningDate
                ? new Date(employee.employeeJoiningDate).toLocaleDateString()
                : "NA"}
            </p>
            <p>
              <strong>Leaving Date:</strong>{" "}
              {employee?.employeeLeavingDate
                ? new Date(employee.employeeLeavingDate).toLocaleDateString()
                : "NA"}
            </p>
            <p>
              <strong>Gender:</strong>{" "}
              {renderValue(employee?.personalDetails?.gender)}
            </p>
            <p>
              <strong>Marital Status:</strong>{" "}
              {renderValue(employee?.personalDetails?.maritalStatus)}
            </p>
            <p>
              <strong>Date of Birth:</strong>{" "}
              {employee?.personalDetails?.dateOfBirth
                ? new Date(
                    employee.personalDetails.dateOfBirth
                  ).toLocaleDateString()
                : "NA"}
            </p>
            <p>
              <strong>Blood Group:</strong>{" "}
              {renderValue(employee?.personalDetails?.bloodGroup)}
            </p>
            <p>
              <strong>Nationality:</strong>{" "}
              {renderValue(employee?.personalDetails?.nationality)}
            </p>
          </div>
        </div>

        {hasReadPermission(userData.permissions, "employee_password") && (
          <div className="bg-white rounded-2xl shadow-sm border p-6 w-full mb-4 mx-auto">
            <div className="flex justify-between items-center mb-3">
              <h2 className="font-semibold text-lg">Login Details</h2>
              <button
                onClick={() => setShowPasswordModal(true)}
                className="text-blue-600 flex justify-center items-center"
              >
                <FaKey /> <span className="mx-2">Change Password</span>
              </button>
            </div>

            <p>
              <strong>username:</strong>{" "}
              {renderValue(employee?.loginDetails?.username)}
            </p>
            <p>
              <strong>paasword:</strong>{" "}
              {renderValue(employee?.loginDetails?.password)}
            </p>
          </div>
        )}
        {hasReadPermission(userData.permissions, "employee_managerdetails") && (
          <div className="bg-white rounded-2xl shadow-sm border p-6 w-full mb-4 mx-auto">
            <div className="flex justify-between items-center mb-3">
              <h2 className="font-semibold text-lg">Reporting Details</h2>
              <button
                onClick={() => setShowManagerModal(true)}
                className="text-blue-600 flex justify-center items-center"
              >
                <FiEdit2 /> <span className="mx-2">Update Manager</span>
              </button>
            </div>

            <p>
              <strong>Manager Name:</strong>{" "}
              {renderValue(employee?.reportingDetails?.managerName)}
            </p>
            <p>
              <strong>Manager Id:</strong>{" "}
              {renderValue(employee?.reportingDetails?.managerEmployeeCode)}
            </p>
            <p>
              <strong>Manager Obj Id</strong>{" "}
              {renderValue(employee?.reportingDetails?.managerObjId)}
            </p>
          </div>
        )}
        {hasReadPermission(userData.permissions, "employee_bankdetails") && (
          <BankDetailsCard
            employee={employee}
            onUpdate={fetchEmployeeDetails}
            userData={userData}
          />
        )}
        {hasReadPermission(userData.permissions, "employee_offerdetails") && (
          <OfferDetailsCard
            employee={employee}
            onUpdate={fetchEmployeeDetails}
            userData={userData}
          />
        )}

        {/* <ReportingPermissionCard/> */}
        <ReportingPermissionCard
          employee={employee}
          employeeObjId={employeeObjId}
          initialPermission={true}
        />

        {/* <BankDetailsCard
          employee={employee}
          onUpdate={fetchEmployeeDetails}
          userData={userData}
        /> */}
        {/* <OfferDetailsCard
          employee={employee}
          onUpdate={fetchEmployeeDetails}
          userData={userData}
        /> */}
        {hasReadPermission(userData.permissions, "employee_exitprocess") && (
          <div className="bg-white rounded-2xl shadow-sm border p-6 w-full mb-4 mx-auto">
            <button
              variant="destructive"
              onClick={() => setShowExitModal(true)}
              className="text-white bg-red-600 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-[#FF9119]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:hover:bg-red-700 dark:focus:ring-[#FF9119]/40 "
            >
              Initiate Exit Process
            </button>
          </div>
        )}
        {showExitModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 w-[90%] max-w-lg shadow-xl relative">
              <h2 className="text-xl font-semibold mb-4">
                Exit Process Details
              </h2>

              <div className="space-y-4">
                <div>
                  <label className="block mb-1 font-medium">
                    Employee Status
                  </label>
                  <select
                    className="w-full border p-2 rounded"
                    value={employeeStatus}
                    onChange={(e) => setemployeeStatus(e.target.value)}
                  >
                    <option value="">Select status</option>
                    <option value="inactive">Inactive</option>
                    <option value="resigned">Resigned</option>
                    <option value="absconded">Absconded</option>
                    <option value="retired">Retired</option>
                    <option value="terminated">Terminated</option>
                  </select>
                </div>

                <div>
                  <label className="block mb-1 font-medium">
                    Exit Initiated Date
                  </label>
                  <input
                    type="date"
                    className="w-full border p-2 rounded"
                    value={exitData.exitInitiatedDate}
                    onChange={(e) =>
                      setExitData({
                        ...exitData,
                        exitInitiatedDate: e.target.value,
                      })
                    }
                  />
                </div>

                <div>
                  <label className="block mb-1 font-medium">
                    Last Working Day
                  </label>
                  <input
                    type="date"
                    className="w-full border p-2 rounded"
                    value={exitData.lastWorkingDay}
                    onChange={(e) =>
                      setExitData({
                        ...exitData,
                        lastWorkingDay: e.target.value,
                      })
                    }
                  />
                </div>

                <div>
                  <label className="block mb-1 font-medium">Exit Reason</label>
                  <textarea
                    className="w-full border p-2 rounded"
                    rows={3}
                    value={exitData.exitReason}
                    onChange={(e) =>
                      setExitData({ ...exitData, exitReason: e.target.value })
                    }
                  />
                </div>

                <div>
                  <label className="block mb-1 font-medium">
                    Clearance Status
                  </label>
                  <select
                    className="w-full border p-2 rounded"
                    value={exitData.clearanceStatus}
                    onChange={(e) =>
                      setExitData({
                        ...exitData,
                        clearanceStatus: e.target.value,
                      })
                    }
                  >
                    <option value="">Select clearance status</option>
                    <option value="in-progress">In Progress</option>
                    <option value="completed">Completed</option>
                    <option value="pending">Pending</option>
                  </select>
                </div>
              </div>

              <div className="flex justify-end space-x-4 mt-6">
                <button
                  variant="secondary"
                  onClick={() => setShowExitModal(false)}
                  className="bg-gray-500 px-3 py-1 rounded-md"
                >
                  Cancel
                </button>
                <button
                  className="bg-blue-500 px-3 py-1 rounded-md text-white"
                  onClick={handleExitSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}

        {showManagerModal && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 w-full max-w-md">
              <h3 className="text-lg font-semibold mb-4">Assign Manager</h3>
              <input
                type="text"
                placeholder="Search Manager"
                className="w-full mb-3 border rounded px-3 py-2"
                value={managerSearch}
                onChange={(e) => setManagerSearch(e.target.value)}
              />
              {managerOptions.length !== 0 ? (
                <div className="max-h-40 overflow-y-auto mb-3 border p-2 rounded">
                  {managerOptions.map((opt) => (
                    <div
                      key={opt._id}
                      onClick={() => {
                        setReportingDetails({
                          managerName:
                            opt.personalDetails?.firstName +
                            " " +
                            opt.personalDetails?.lastName,
                          managerEmployeeCode: opt.employeeCode,
                          managerId: opt.employeeDetails?.employeeId,
                          managerObjId: opt._id,
                        });
                        setManagerSelected(true);
                        setManagerSearch("");
                        setManagerOptions([]);
                      }}
                      className="p-2 hover:bg-gray-100 cursor-pointer border-b"
                    >
                      {opt.personalDetails?.firstName}{" "}
                      {opt.personalDetails?.lastName} - {opt.employeeCode}
                    </div>
                  ))}
                </div>
              ) : null}
              {managerSelected && (
                <div className="text-sm bg-gray-100 p-3 rounded mb-3">
                  Selected Manager:{" "}
                  <strong>{reportingDetails.managerName || "N/A"}</strong>
                </div>
              )}
              <div className="flex justify-end space-x-2">
                <button
                  className="bg-gray-200 px-4 py-2 rounded"
                  onClick={() => setShowManagerModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="bg-blue-600 text-white px-4 py-2 rounded"
                  onClick={updateManager}
                  disabled={!reportingDetails.managerObjId}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        )}

        {showPasswordModal && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 w-full max-w-md">
              <h3 className="text-lg font-semibold mb-4">Change Password</h3>
              <input
                type="password"
                placeholder="New Password"
                className="w-full mb-3 border rounded px-3 py-2"
                value={passwords.newPassword}
                onChange={(e) =>
                  setPasswords({ ...passwords, newPassword: e.target.value })
                }
              />
              <input
                type="password"
                placeholder="Confirm Password"
                className="w-full mb-3 border rounded px-3 py-2"
                value={passwords.confirmPassword}
                onChange={(e) =>
                  setPasswords({
                    ...passwords,
                    confirmPassword: e.target.value,
                  })
                }
              />
              <div className="flex justify-end space-x-2">
                <button
                  className="bg-gray-200 px-4 py-2 rounded"
                  onClick={() => setShowPasswordModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="bg-blue-600 text-white px-4 py-2 rounded"
                  onClick={updatePassword}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        )}
        {showUpdateModal && selectedEmployee && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 w-[90%] max-w-2xl shadow-xl relative overflow-y-auto max-h-[90vh]">
              <h2 className="text-xl font-semibold mb-4">
                Update Employee Details ({selectedEmployee.employeeCode})
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Employee Status */}
                <div>
                  <label className="block mb-1 font-medium">
                    Employee Status
                  </label>
                  <select
                    className="w-full border p-2 rounded"
                    value={selectedEmployee.employeeStatus}
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        employeeStatus: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    <option value="resigned">Resigned</option>
                    <option value="terminated">Terminated</option>
                    <option value="resigned">Resigned</option>
                    <option value="draft">Draft</option>
                  </select>
                </div>
                <div>
                  <label className="block mb-1 font-medium">Employee Id</label>
                  <input
                    type="text"
                    className="w-full border p-2 rounded"
                    value={selectedEmployee.employeeId || ""}
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        employeeId: e.target.value,
                      }))
                    }
                  />
                </div>

                {/* Date of Birth */}
                <div>
                  <label className="block mb-1 font-medium">
                    Date of Birth
                  </label>
                  <input
                    type="date"
                    className="w-full border p-2 rounded"
                    value={
                      selectedEmployee.personalDetails?.dateOfBirth?.split(
                        "T"
                      )[0] || ""
                    }
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        personalDetails: {
                          ...prev.personalDetails,
                          dateOfBirth: e.target.value,
                        },
                      }))
                    }
                  />
                </div>

                {/* Department */}
                <div>
                  <label className="block mb-1 font-medium">Department</label>
                  <select
                    className="w-full border p-2 rounded"
                    value={selectedEmployee.department || ""}
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        department: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select department</option>
                    <option value="hr">HR</option>
                    <option value="sales">Sales</option>
                    <option value="hr-payroll">HR Payroll</option>
                    <option value="hr-operations">HR Operations</option>
                    <option value="hr-recruitment">HR Recruitment</option>
                    <option value="mis">MIS</option>
                    <option value="it-support">It Support</option>
                    <option value="training-and-development">
                      Training and Development
                    </option>
                    <option value="research-and-development">
                      Research and Development
                    </option>
                    <option value="legal">Legal</option>
                    <option value="administration">Administration</option>
                    <option value="quality-assurance">Quality Assurance</option>
                    <option value="logistics">Logistics</option>
                    <option value="finance">Finance</option>
                    <option value="confirmation">Confirmation</option>
                  </select>
                </div>

                {/* Designation */}
                <div>
                  <label className="block mb-1 font-medium">Designation</label>
                  <select
                    className="w-full border p-2 rounded"
                    value={selectedEmployee.designation || ""}
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        designation: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select designation</option>
                    <option value="executive">Executive</option>
                    <option value="recruiter">Recruiter</option>
                    <option value="intern">Intern</option>
                    <option value="admin-officer">Admin Officer</option>
                    <option value="personal-security-officer">Personal Security Officer</option>
                    <option value="senior-executive">Senior Executive</option>
                    <option value="team-lead">Team Lead</option>
                    <option value="senior-team-lead">Senior Team Lead</option>
                    <option value="senior-manager">Senior Manager</option>
                    <option value="manager">Manager</option>
                    <option value="sales-head">Sales Head</option>
                    <option value="assistant-manager">Assistant Manager</option>
                    <option value="payroll-specialist">
                      Payroll Specialist
                    </option>
                  </select>
                </div>

                {/* First Name */}
                <div>
                  <label className="block mb-1 font-medium">First Name</label>
                  <input
                    type="text"
                    className="w-full border p-2 rounded"
                    value={selectedEmployee.personalDetails?.firstName || ""}
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        personalDetails: {
                          ...prev.personalDetails,
                          firstName: e.target.value,
                        },
                      }))
                    }
                  />
                </div>

                {/* Last Name */}
                <div>
                  <label className="block mb-1 font-medium">Last Name</label>
                  <input
                    type="text"
                    className="w-full border p-2 rounded"
                    value={selectedEmployee.personalDetails?.lastName || ""}
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        personalDetails: {
                          ...prev.personalDetails,
                          lastName: e.target.value,
                        },
                      }))
                    }
                  />
                </div>

                {/* Gender */}
                <div>
                  <label className="block mb-1 font-medium">Gender</label>
                  <select
                    className="w-full border p-2 rounded"
                    value={selectedEmployee.personalDetails?.gender || ""}
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        personalDetails: {
                          ...prev.personalDetails,
                          gender: e.target.value,
                        },
                      }))
                    }
                  >
                    <option value="">Select gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                {/* Marital Status */}
                <div>
                  <label className="block mb-1 font-medium">
                    Marital Status
                  </label>
                  <select
                    className="w-full border p-2 rounded"
                    value={
                      selectedEmployee.personalDetails?.maritalStatus || ""
                    }
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        personalDetails: {
                          ...prev.personalDetails,
                          maritalStatus: e.target.value,
                        },
                      }))
                    }
                  >
                    <option value="">Marital Status</option>
                    <option value="unmarried">unmarried</option>
                    <option value="married">married</option>
                    <option value="divorced">divorced</option>
                    <option value="widowed">widowed</option>
                  </select>
                </div>

                {/* Phone */}
                <div>
                  <label className="block mb-1 font-medium">Phone</label>
                  <input
                    type="text"
                    className="w-full border p-2 rounded"
                    value={selectedEmployee.personalDetails?.phone || ""}
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        personalDetails: {
                          ...prev.personalDetails,
                          phone: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
                <div>
                  <label className="block mb-1 font-medium">Email</label>
                  <input
                    type="text"
                    className="w-full border p-2 rounded"
                    value={selectedEmployee.personalDetails?.email || ""}
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        personalDetails: {
                          ...prev.personalDetails,
                          email: e.target.value,
                        },
                      }))
                    }
                  />
                </div>

                {/* Aadhar Number */}
                <div>
                  <label className="block mb-1 font-medium">
                    Aadhar Number
                  </label>
                  <input
                    type="text"
                    className="w-full border p-2 rounded"
                    value={selectedEmployee.identification?.aadharNumber || ""}
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        identification: {
                          ...prev.identification,
                          aadharNumber: e.target.value,
                        },
                      }))
                    }
                  />
                </div>

                {/* PAN Number */}
                <div>
                  <label className="block mb-1 font-medium">PAN Number</label>
                  <input
                    type="text"
                    className="w-full border p-2 rounded"
                    value={selectedEmployee.identification?.panNumber || ""}
                    onChange={(e) =>
                      setSelectedEmployee((prev) => ({
                        ...prev,
                        identification: {
                          ...prev.identification,
                          panNumber: e.target.value,
                        },
                      }))
                    }
                  />
                </div>
              </div>

              <div className="flex justify-end gap-4 mt-6">
                <button
                  onClick={() => setShowUpdateModal(false)}
                  className="bg-gray-500 px-4 py-2 text-white rounded"
                >
                  Cancel
                </button>
                <button
                  onClick={handleUpdateEmployee}
                  className="bg-blue-600 px-4 py-2 text-white rounded"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
      </Container>
    </Layout>
  );
}

const BankDetailsCard = ({ employee, onUpdate, userData }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(employee?.bankDetails || {});

  const handleSave = async () => {
    try {
      const payload = {
        employeeObjId: employee._id,
        bankDetails: editData,
        verificationBy: {
          userObjId: userData?._id,
        },
      };

      const res = await axios.patch(
        `${apiurl}/api/employee/update-bankdetails`,
        payload
      );

      if (res.status === 200) {
        onUpdate && onUpdate();
        setIsEditing(false);
        toast.success("bank details update successfully");
      } else {
        alert(res.data?.message || "Failed to update");
      }
    } catch (err) {
      console.error("Error saving bank details:", err);
      alert(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <>
      <div className="bg-white rounded-2xl shadow-sm border p-6 w-full mb-4 mx-auto relative">
        <div className="flex justify-between items-center">
          <h3 className="font-semibold text-lg">Bank Details</h3>
          <FaEdit
            onClick={() => {
              setEditData(employee?.bankDetails);
              setIsEditing(true);
            }}
            className="text-blue-600 cursor-pointer"
          />
        </div>
        <div className="grid grid-cols-2 gap-2 mt-4 text-sm">
          <p>
            <strong>Bank:</strong> {employee?.bankDetails?.bankName || "-"}
          </p>
          <p>
            <strong>Holder:</strong>{" "}
            {employee?.bankDetails?.accountHolderName || "-"}
          </p>
          <p>
            <strong>Account:</strong>{" "}
            {employee?.bankDetails?.accountNumber || "-"}
          </p>
          <p>
            <strong>IFSC:</strong> {employee?.bankDetails?.ifscCode || "-"}
          </p>
          <p>
            <strong>Branch:</strong> {employee?.bankDetails?.branchName || "-"}
          </p>
          <p>
            <strong>Type:</strong> {employee?.bankDetails?.accountType || "-"}
          </p>
          <p>
            <strong>Status:</strong>{" "}
            {employee?.bankDetails?.verificationStatus || "-"}
          </p>
          <p>
            <strong>Remarks:</strong>{" "}
            {employee?.bankDetails?.verificationRemarks || "-"}
          </p>
        </div>
      </div>

      {isEditing && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-md w-[90%] max-w-3xl">
            <h2 className="text-lg font-semibold mb-4">Edit Bank Details</h2>
            <div className="grid grid-cols-2 gap-4">
              {[
                ["bankName", "Bank Name"],
                ["accountHolderName", "Account Holder Name"],
                ["accountNumber", "Account Number"],
                ["confirmAccountNumber", "Confirm Account Number"],
                ["ifscCode", "IFSC Code"],
                ["branchName", "Branch Name"],
                ["verificationRemarks", "Verification Remarks"],
              ].map(([key, label]) => (
                <input
                  key={key}
                  type="text"
                  placeholder={label}
                  className="border p-2 rounded"
                  value={editData?.[key] || ""}
                  onChange={(e) =>
                    setEditData((prev) => ({ ...prev, [key]: e.target.value }))
                  }
                />
              ))}

              <select
                className="border p-2 rounded"
                value={editData?.accountType || ""}
                onChange={(e) =>
                  setEditData((prev) => ({
                    ...prev,
                    accountType: e.target.value,
                  }))
                }
              >
                <option value="">Select Account Type</option>
                <option value="savings">Savings</option>
                <option value="current">Current</option>
                <option value="fixed-deposit">Fixed Deposit</option>
              </select>

              <select
                className="border p-2 rounded"
                value={editData?.verificationStatus || ""}
                onChange={(e) =>
                  setEditData((prev) => ({
                    ...prev,
                    verificationStatus: e.target.value,
                  }))
                }
              >
                <option value="">Select Status</option>
                <option value="pending">Pending</option>
                <option value="verified">Verified</option>
                <option value="rejected">Rejected</option>
              </select>
            </div>

            <div className="flex justify-end mt-6 gap-2">
              <button
                onClick={() => setIsEditing(false)}
                className="px-4 py-2 bg-gray-300 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const OfferDetailsCard = ({ employee, onUpdate, userData }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(
    employee?.offerDetails || {
      workSchedule: "",
      offerLetterDate: "",
      offerAcceptedDate: "",
      joiningDate: "",
      onboardingCompleted: false,
      offerLetterLink: "",
      offerLetterStatus: "pending",
      offerLetterRemarks: "",
      salaryDetails: {
        offeredCTC: 0,
        monthlySalary: 0,
        currency: "INR",
        salaryMode: "monthly",
        components: {
          basic: 0,
          hra: 0,
          special: 0,
          bonus: 0,
          other: 0,
        },
        deductions: {
          pf: 0,
          esi: 0,
        },
        remarks: "",
      },
    }
  );

  const calculateSalaryComponents = (monthlySalary) => {
    const salary = parseFloat(monthlySalary);
    if (isNaN(salary) || salary <= 0) {
      return {
        offeredCTC: 0,
        basic: 0,
        hra: 0,
        other: 0,
      };
    }

    const offeredCTC = Math.round(salary * 12);
    const basic = Math.round(salary * 0.2);
    const hra = Math.round(basic * 0.5);
    const other = Math.round(salary - basic - hra);

    return {
      offeredCTC,
      basic,
      hra,
      other,
    };
  };

  const handleSave = async () => {
    try {
      const payload = {
        employeeObjId: employee._id,
        offerDetails: editData,
        verificationBy: {
          userObjId: userData?._id,
        },
      };

      const res = await axios.patch(
        `${apiurl}/api/employee/update-salarydetails`,
        payload
      );

      if (res.status === 200) {
        onUpdate && onUpdate();
        setIsEditing(false);
        toast.success("update succefully");
      } else {
        alert(res.data?.message || "Failed to update");
      }
    } catch (err) {
      console.error("Error saving offer details:", err);
      alert(err.response?.data?.message || "Something went wrong");
    }
  };
  useEffect(() => {
    const components = calculateSalaryComponents(
      editData.salaryDetails?.monthlySalary || 0
    );

    setEditData((prev) => ({
      ...prev,
      salaryDetails: {
        ...prev.salaryDetails,
        offeredCTC: components.offeredCTC, // sync yearly
        components: {
          ...prev.salaryDetails.components,
          basic: components.basic,
          hra: components.hra,
          other: components.other,
        },
      },
    }));
  }, [editData.salaryDetails?.monthlySalary]);

  return (
    <>
      <div className="bg-white rounded-2xl shadow-sm border p-6 w-full mb-4 mx-auto relative">
        <div className="flex justify-between items-center">
          <h3 className="font-semibold text-lg">Offer & Salary Details</h3>
          <FaEdit
            onClick={() => {
              setEditData(employee?.offerDetails || {});
              setIsEditing(true);
            }}
            className="text-blue-600 cursor-pointer"
          />
        </div>
        <div className="grid grid-cols-2 gap-2 mt-4 text-sm">
          <p>
            <strong>Work Schedule:</strong> {editData.workSchedule || "-"}
          </p>

          <p>
            <strong>Joining Date:</strong>{" "}
            {employee?.offerDetails?.joiningDate?.slice(0, 10) || "-"}
          </p>
          <p>
            <strong>Offer Letter Date:</strong>{" "}
            {editData.offerLetterDate?.slice(0, 10) || "-"}
          </p>
          <p>
            <strong>Offer Accepted Date:</strong>{" "}
            {editData.offerAcceptedDate?.slice(0, 10) || "-"}
          </p>
          <p>
            <strong>Onboarding Completed:</strong>{" "}
            {editData.onboardingCompleted ? "Yes" : "No"}
          </p>
          <p>
            <strong>Offer Letter Status:</strong>{" "}
            {editData.offerLetterStatus || "-"}
          </p>
          <p>
            <strong>Offer Letter Link:</strong>{" "}
            {employee?.offerDetails?.offerLetterLink ? (
              <a
                href={editData.offerLetterLink}
                className="text-blue-600 underline"
                target="_blank"
                rel="noreferrer"
              >
                View
              </a>
            ) : (
              <spna>
                <GoInfo className="inline text-red-500" />
              </spna>
            )}
          </p>
          <p className="col-span-2">
            <strong>Offer Letter Remarks:</strong>{" "}
            {editData.offerLetterRemarks || "-"}
          </p>

          <p>
            <strong>Offered Yearly CTC:</strong>{" "}
            {employee?.offerDetails?.salaryDetails?.offeredCTC || "-"}
          </p>
          <p>
            <strong>Monthly Salary:</strong>{" "}
            {employee?.offerDetails?.salaryDetails?.monthlySalary || "-"}
          </p>
          <p>
            <strong>Currency:</strong> {editData.salaryDetails?.currency || "-"}
          </p>
          <p>
            <strong>Salary Mode:</strong>{" "}
            {editData.salaryDetails?.salaryMode || "-"}
          </p>

          <p>
            <strong>Basic:</strong>{" "}
            {employee?.offerDetails?.salaryDetails?.components?.basic || "-"}
          </p>
          <p>
            <strong>HRA:</strong>{" "}
            {employee?.offerDetails?.salaryDetails?.components?.hra || "-"}
          </p>
          <p>
            <strong>Special:</strong>{" "}
            {employee?.offerDetails?.salaryDetails?.components?.special || "-"}
          </p>
          <p>
            <strong>Bonus:</strong>{" "}
            {employee?.offerDetails?.salaryDetails?.components?.bonus || "-"}
          </p>
          <p>
            <strong>Other:</strong>{" "}
            {employee?.offerDetails?.salaryDetails?.components?.other || "-"}
          </p>
          <p className="col-span-2">
            <strong>Salary Remarks:</strong>{" "}
            {editData.salaryDetails?.remarks || "-"}
          </p>
        </div>
      </div>

      {isEditing && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-md w-[90%] max-w-4xl overflow-auto max-h-[90vh]">
            <h2 className="text-lg font-semibold mb-4">
              Edit Offer & Salary Details
            </h2>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <label className="block mb-1">Work Schedule</label>
                <select
                  value={editData.workSchedule}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      workSchedule: e.target.value,
                    }))
                  }
                  className="border p-2 rounded w-full"
                >
                  <option value="5-day">5-day</option>
                  <option value="6-day">6-day</option>
                  <option value="rotational">Rotational</option>
                </select>
              </div>

              <div>
                <label className="block mb-1">Joining Date</label>
                <input
                  type="date"
                  value={editData.joiningDate?.slice(0, 10) || ""}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      joiningDate: e.target.value,
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div>

              <div>
                <label className="block mb-1">Offer Letter Date</label>
                <input
                  type="date"
                  value={editData.offerLetterDate?.slice(0, 10) || ""}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      offerLetterDate: e.target.value,
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div>

              <div>
                <label className="block mb-1">Offer Accepted Date</label>
                <input
                  type="date"
                  value={editData.offerAcceptedDate?.slice(0, 10) || ""}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      offerAcceptedDate: e.target.value,
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div>

              <div className="col-span-2">
                <label className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={editData.onboardingCompleted}
                    onChange={(e) =>
                      setEditData((prev) => ({
                        ...prev,
                        onboardingCompleted: e.target.checked,
                      }))
                    }
                  />
                  <span>Onboarding Completed</span>
                </label>
              </div>

              <div>
                <label className="block mb-1">Offer Letter Status</label>
                <select
                  value={editData.offerLetterStatus}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      offerLetterStatus: e.target.value,
                    }))
                  }
                  className="border p-2 rounded w-full"
                >
                  <option value="pending">Pending</option>
                  <option value="accepted">Accepted</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>

              <div className="col-span-2">
                <label className="block mb-1">Offer Letter Link</label>
                <input
                  type="text"
                  placeholder="Offer Letter Link"
                  value={editData.offerLetterLink || ""}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      offerLetterLink: e.target.value,
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div>

              <div className="col-span-2">
                <label className="block mb-1">Offer Letter Remarks</label>
                <textarea
                  placeholder="Offer Letter Remarks"
                  className="border p-2 rounded w-full"
                  value={editData.offerLetterRemarks || ""}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      offerLetterRemarks: e.target.value,
                    }))
                  }
                />
              </div>

              <div>
                <label className="block mb-1">Monthly Salary</label>
                <input
                  type="number"
                  value={editData.salaryDetails?.monthlySalary || 0}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      salaryDetails: {
                        ...prev.salaryDetails,
                        monthlySalary: Number(e.target.value),
                      },
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div>
              {/* 
              <div>
                <label className="block mb-1">Offered CTC</label>
                <input
                  type="number"
                  value={editData.salaryDetails?.offeredCTC || 0}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      salaryDetails: {
                        ...prev.salaryDetails,
                        offeredCTC: Number(e.target.value),
                      },
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div> */}

              <div>
                <label className="block mb-1">Offered CTC (Yearly)</label>
                <input
                  type="number"
                  value={editData.salaryDetails?.offeredCTC || 0}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      salaryDetails: {
                        ...prev.salaryDetails,
                        offeredCTC: Number(e.target.value), // manual override allowed
                      },
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div>

              <div>
                <label className="block mb-1">Currency</label>
                <input
                  type="text"
                  readOnly
                  value={editData.salaryDetails?.currency || ""}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      salaryDetails: {
                        ...prev.salaryDetails,
                        currency: e.target.value,
                      },
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div>
              <div>
                <label className="block mb-1">Salary Mode</label>
                <input
                  type="text"
                  readOnly
                  value={editData.salaryDetails?.salaryMode || ""}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      salaryDetails: {
                        ...prev.salaryDetails,
                        salaryMode: e.target.value,
                      },
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div>

              {/* <div>
                <label className="block mb-1">Salary Mode</label>
                <select
                  value={editData.salaryDetails?.salaryMode || "monthly"}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      salaryDetails: {
                        ...prev.salaryDetails,
                        salaryMode: e.target.value,
                      },
                    }))
                  }
                  className="border p-2 rounded w-full"
                >
                  <option value="monthly">Monthly</option>
                  <option value="weekly">Weekly</option>
                  <option value="hourly">Hourly</option>
                </select>
              </div> */}

              <div>
                <label className="block mb-1">Basic</label>
                <input
                  type="number"
                  value={calculateSalaryComponents(
                    editData.salaryDetails?.monthlySalary
                  ).basic.toFixed(2)}
                  readOnly
                  className="border p-2 rounded w-full bg-gray-100"
                />
              </div>

              <div>
                <label className="block mb-1">HRA</label>
                <input
                  type="number"
                  value={calculateSalaryComponents(
                    editData.salaryDetails?.monthlySalary
                  ).hra.toFixed(2)}
                  readOnly
                  className="border p-2 rounded w-full bg-gray-100"
                />
              </div>

              <div>
                <label className="block mb-1">Special</label>
                <input
                  type="number"
                  value={editData.salaryDetails?.components?.special || 0}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      salaryDetails: {
                        ...prev.salaryDetails,
                        components: {
                          ...prev.salaryDetails.components,
                          special: Number(e.target.value),
                        },
                      },
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div>

              <div>
                <label className="block mb-1">Bonus</label>
                <input
                  type="number"
                  value={editData.salaryDetails?.components?.bonus || 0}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      salaryDetails: {
                        ...prev.salaryDetails,
                        components: {
                          ...prev.salaryDetails.components,
                          bonus: Number(e.target.value),
                        },
                      },
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div>

              <div>
                <label className="block mb-1">Other</label>
                <input
                  type="number"
                  value={calculateSalaryComponents(
                    editData.salaryDetails?.monthlySalary
                  ).other.toFixed(2)}
                  readOnly
                  className="border p-2 rounded w-full bg-gray-100"
                />
              </div>

              {/* {[
                { key: "basic", label: "Basic" },
                { key: "hra", label: "HRA" },
                { key: "special", label: "Special" },
                { key: "bonus", label: "Bonus" },
                { key: "other", label: "Other" },
              ].map(({ key, label }) => (
                <div key={key}>
                  <label className="block mb-1">{label}</label>
                  <input
                    type="number"
                    className="border p-2 rounded w-full"
                    value={editData.salaryDetails?.components?.[key] || 0}
                    onChange={(e) =>
                      setEditData((prev) => ({
                        ...prev,
                        salaryDetails: {
                          ...prev.salaryDetails,
                          components: {
                            ...prev.salaryDetails.components,
                            [key]: Number(e.target.value),
                          },
                        },
                      }))
                    }
                  />
                </div>
              ))} */}

              <div className="col-span-2">
                <label className="block mb-1">Salary Remarks</label>
                <textarea
                  placeholder="Salary Remarks"
                  className="border p-2 rounded w-full"
                  value={editData.salaryDetails?.remarks || ""}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      salaryDetails: {
                        ...prev.salaryDetails,
                        remarks: e.target.value,
                      },
                    }))
                  }
                />
              </div>

              <div>
                <label className="block mb-1">PF</label>
                <input
                  type="number"
                  value={editData.salaryDetails?.deductions?.pf || 0}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      salaryDetails: {
                        ...prev.salaryDetails,
                        deductions: {
                          ...prev.salaryDetails.deductions,
                          pf: Number(e.target.value),
                        },
                      },
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div>

              <div>
                <label className="block mb-1">ESI</label>
                <input
                  type="number"
                  value={editData.salaryDetails?.deductions?.esi || 0}
                  onChange={(e) =>
                    setEditData((prev) => ({
                      ...prev,
                      salaryDetails: {
                        ...prev.salaryDetails,
                        deductions: {
                          ...prev.salaryDetails.deductions,
                          esi: Number(e.target.value),
                        },
                      },
                    }))
                  }
                  className="border p-2 rounded w-full"
                />
              </div>
            </div>

            <div className="flex justify-end mt-6 gap-2">
              <button
                onClick={() => setIsEditing(false)}
                className="px-4 py-2 bg-gray-300 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const ReportingPermissionCard = ({ employee, employeeObjId }) => {
  const [hasPermission, setHasPermission] = useState(false);
  const [loading, setLoading] = useState(false);

  // Check if employee has reporting permission on mount
  useEffect(() => {
    const reportingPerm = employee?.permissions?.find(
      (perm) => perm.resource === "reporting"
    );
    setHasPermission(!!reportingPerm);
  }, [employee]);

  const handleTogglePermission = async () => {
    setLoading(true);
    try {
      if (hasPermission) {
        await axios.post(
          `${apiurl}/api/employee/remove-permission`,
          {
            employeeObjId,
            resource: "reporting",
          }
        );
        setHasPermission(false);
      } else {
        await axios.post(`${apiurl}/api/employee/add-permission`, {
          employeeObjId,
          resource: "reporting",
          read: true,
          write: false,
          update: true,
          delete: false,
        });
        setHasPermission(true);
      }
    } catch (error) {
      alert("Error: " + (error.response?.data?.message || error.message));
    }
    setLoading(false);
  };

  return (
    <div className="my-3 p-4 rounded-xl shadow-md border bg-white">
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-lg font-semibold">Reporting Access</h3>
          <p className="text-sm mt-1 text-gray-500">
            Read: ✅ | Update: ✅ | Write: ❌ | Delete: ❌
          </p>
        </div>
        <button
          onClick={handleTogglePermission}
          className={`my-3 px-4 py-2 rounded-lg text-white transition ${
            hasPermission
              ? "bg-red-500 hover:bg-red-600"
              : "bg-green-500 hover:bg-green-600"
          }`}
          disabled={loading}
        >
          {loading
            ? "Processing..."
            : hasPermission
            ? "Remove Access"
            : "Grant Access"}
        </button>
      </div>
    </div>
  );
};
